import { Link, useNavigate } from "react-router-dom";
import NoData from "../../assets/img/nodata_gray.svg"
import { useEffect, useState } from "react";
import useAdminsRequest from "../../hooks/useAdminsRequest";
import AppSpinner from "../elements/AppSpinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import usePermissionsRequest from "./usePermissionsRequest";
import useRolesRequest from "./useRolesRequest";


const AdminPage = () => {
    const navigate = useNavigate()
    const [activeTab, setActivetab] = useState("users");

    return (
        <div>
            <div className="text-sm font-medium text-center text-gray-500  mx-2 ">
                <ul className="flex flex-wrap -mb-px">
                    <li className="mr-2">
                        <a onClick={() => setActivetab('users')} href="#!" className={(activeTab === 'users') ? "tab-active" : "tab-inactive"}>Users</a>
                    </li>
                    <li className="mr-2">
                        <a onClick={() => setActivetab('roles')} href="#!" className={(activeTab === 'roles') ? "tab-active" : "tab-inactive"} aria-current="page">Roles</a>
                    </li>
                    {/* <li className="mr-2">
                        <a onClick={() => setActivetab('permissions')} href="#!" className={(activeTab === 'permissions') ? "tab-active" : "tab-inactive"} aria-current="page">Permissions</a>
                    </li> */}
                </ul>
            </div>


            {

                (activeTab === 'users') ?
                    <UsersCard /> :
                    <RolesCard />
            }
        </div>
    )
}


const RolesCard = () => {
    const navigate = useNavigate()
    const { fetchingRoles, roles, getRoles } = useRolesRequest()
    useEffect(() => {
        getRoles()
    }, [])
    return (
        <>
            <div className="card">
                <div className="card-body min-h-half-screen">
                <div className="flex">
                        <nav className="flex justify-between " aria-label="Breadcrumb">
                            <ol className="inline-flex items-center mb-3 sm:mb-0">
                                <li>
                                    <div className="flex items-center">
                                        <h5 className=" card-title ">Users</h5>
                                    </div>
                                </li>

                            </ol>
                        </nav>
                        <div className="flex-grow flex justify-end">
                            <button onClick={() => navigate("/create-role")} type="button" className="prim-btn-2 mb-2">New Role</button>
                        </div>
                    </div>
                    <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                        <thead>
                            <tr>
                                <th scope="col">Title</th>
                                <th scope="col">Permissions</th>
                                <th scope="col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                roles.map((item, key) =>
                                    <tr key={key}>
                                        <td>{item.name} </td>
                                        <td>
                                            {item.permissions.map((permission, key) =>
                                                <div key={key} className="flex flex-col gap-1">
                                                    {permission}
                                                </div>
                                            )}
                                        </td>
                                        <td>
                                            <span className="flex gap-1">
                                                <FontAwesomeIcon icon={faEdit} />
                                                <FontAwesomeIcon className=" " icon={faTrashAlt} />
                                            </span>
                                        </td>
                                    </tr>
                                )
                            }

                        </tbody>
                    </table>

                </div>
            </div>
        </>
    )
}

const PermissionsCard = () => {
    const { fetchingPermissions, permissions, getPermissions } = usePermissionsRequest()
    useEffect(() => {
        getPermissions()
    }, [])
    return (
        <>
            <div className="card">
                <div className="card-body min-h-half-screen">
                    <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                        <thead>
                            <tr>
                                <th scope="col" >
                                    Name
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                permissions.map((item, key) =>
                                    <tr key={key}>
                                        <td>{item}</td>
                                        {/* <td className=" text-center"> <a className="text-xs text-blue-700 " href="">view users</a></td> */}
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>

                </div>
            </div>
        </>
    )
}

const UsersCard = () => {
    const navigate = useNavigate()
    const { loadingUsers, users, getUsers } = useAdminsRequest();
    useEffect(() => {
        getUsers();
    }, []);
    return (
        <div>
            <div className="card">
                <div className=" card-body min-h-half-screen">
                    <div className="flex">
                        <nav className="flex justify-between " aria-label="Breadcrumb">
                            <ol className="inline-flex items-center mb-3 sm:mb-0">
                                <li>
                                    <div className="flex items-center">
                                        <h5 className=" card-title ">Users</h5>
                                    </div>
                                </li>

                            </ol>
                        </nav>
                        <div className="flex-grow flex justify-end">
                            <button onClick={() => navigate("/create-admins")} type="button" className="prim-btn-2 mb-2">New User</button>
                        </div>
                    </div>
                    {
                        (users.length === 0 && loadingUsers == false) &&
                        <div className=" h-fit flex-grow flex flex-col justify-center ">
                            <div className="flex justify-center">
                                <div>
                                    <img className=" w-32" src={NoData} alt="" />
                                    <p>No Records Yet!</p>
                                </div>
                            </div>
                        </div>
                    }
                    {(loadingUsers) && <AppSpinner />}

                    {(users.length > 0) &&
                        <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                            <thead>
                                <tr>
                                    <th scope="col" >
                                        Name
                                    </th>
                                    <th scope="col" >
                                        Email
                                    </th>
                                    <th scope="col" >
                                        Role
                                    </th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    users.map((item, key) =>
                                        <tr key={key}>
                                            <td>{item.first_name} {item.last_name}</td>
                                            <td>{item.email}</td>
                                            <td>{item.roles.map((item) => item.name).join(", ")}</td>
                                            <td>
                                                <span className="flex gap-1" >
                                                    <Link to={`/update-admin/${item.id}`}>
                                                    <FontAwesomeIcon className=" cursor-pointer" icon={faEdit} />

                                                    </Link>
                                                    <FontAwesomeIcon className=" cursor-pointer" icon={faTrashAlt} />
                                                </span>

                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    }
                </div>
            </div>
        </div>
    )
}




export default AdminPage;